import * as React from 'react';
import { Paragraph, Title } from '@/components/atoms';
import TermsOfService from '@/components/organisms/terms/TermsOfService';
import { Card } from 'antd';
import { BaseTemplate } from '@/components/template';
import { TermsOfPrivacy } from '@/components/organisms';

type TermsOfPrivacyPageProps = {
  title?: string | React.ReactNode;
};

const TermsOfPrivacyPage = ({ title }: TermsOfPrivacyPageProps) => {
  return (
    <BaseTemplate headerShow>
      <Title>{title}</Title>

      <Paragraph>본 방침은 2021년 1월 1일부터 시행됩니다.</Paragraph>
      <Card>
        <TermsOfPrivacy />
      </Card>
    </BaseTemplate>
  );
};

TermsOfPrivacyPage.defaultProps = {
  title: '개인정보 처리방침',
};

export default TermsOfPrivacyPage;
